import { SpotToast } from "@/components/SpotToast";

type CsvColumn = { key: string; header: string };

// RFC-4180-ish escaping: wrap in quotes when the value contains a comma, quote,
// or newline, and double any embedded quotes. Objects are JSON-encoded.
function escapeCsv(value: unknown): string {
  if (value === null || value === undefined) return "";
  const s = typeof value === "object" ? JSON.stringify(value) : String(value);
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function rowsToCsv(
  columns: CsvColumn[],
  rows: Record<string, unknown>[]
): string {
  const lines = [columns.map((c) => escapeCsv(c.header)).join(",")];
  for (const row of rows) {
    lines.push(columns.map((c) => escapeCsv(row[c.key])).join(","));
  }
  return lines.join("\r\n");
}

export function downloadBlob(filename: string, blob: Blob): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export function downloadCsv(filename: string, content: string): void {
  const blob = new Blob([content], { type: "text/csv;charset=utf-8" });
  downloadBlob(
    filename.toLowerCase().endsWith(".csv") ? filename : `${filename}.csv`,
    blob
  );
}

export const IMPORT_MAX_BYTES = 25 * 1024 * 1024;

export function withinImportLimit(file: File): boolean {
  if (file.size <= IMPORT_MAX_BYTES) return true;
  SpotToast.error("This file is larger than the 25 MB import limit.");
  return false;
}
